import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable()
export class PlatformService {
    /**
     * True only for the installed Capacitor app. Ionic `platform.is('mobile'|'ios'|'android')`
     * is also true in a phone-sized browser, which swapped in MobileRoutingModule and
     * sent `/login` to the public listing.
     */
    public isMobilePlatform(): boolean {
      return Capacitor.isNativePlatform();
    }
}
